export default [
  {
    name: 'Modern Wingback Bed',
    sublabel: ' in Verdure Bois de Chene by Old World Weavers',
    image: 'modern-wingback24.jpg',
    url: '/products/modern-wingback-platform-bed-twin-verdure-bois-de-chene-by-old-world-weavers-96290',
    isBestSeller: false,
    fullWidth: true,
    customImgixParams: {
      'fp-x': 0.5,
      'fp-y': 0.5,
      'fp-z': 1.0,
      crop: 'focalpoint'
    }
  },
  {
    name: 'X Bench',
    sublabel: ' in Antelope',
    image: 'x-chair24.jpg',
    url: '/products/x-bench-antelope-49550',
    isBestSeller: true,
    isNew: false,
  },
  {
    name: 'English Roll Arm Chair',
    sublabel: 'in Blue Swallows',
    image: 'eng-chair2024.jpg',
    url: '/products/english-roll-arm-chair-natural-blue-swallows-natural-turned-wood-leg-legs-95062',
    isBestSeller: false,
    fullWidth: false,
  },
  {
    name: 'Classic Dining Chair',
    sublabel: 'in Coral Tigresse',
    image: 'tigress-chair24.jpg',
    url: '/products/classic-dining-chair-requires-assembly-coral-tigresse-natural-natural-legs-50715',
    isBestSeller: false,
    isNew: false,
  },
  {
    name: 'English Roll Arm Sofa',
    sublabel: 'in Olive Everyday Linen',
    image: 'sofaengroll24.jpg',
    url: '/products/english-roll-arm-sofa-espresso-olive-everyday-linen-espresso-turned-wood-leg-legs-94920',
    isBestSeller: true,
    fullWidth: false
  },
  {
    name: 'Printed Curtain',
    sublabel: 'in Delft La Vendee by CW Stockwell',
    image: 'curtcurtain24.jpg',
    url: '/products/printed-linen-privacy-curtain-50-x-108-delft-la-vendee-by-cw-stockwell-60612',
    isBestSeller: false,
    isNew: false,
  },
];
